import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Define supported languages
const supportedLanguages = {
  en: { name: 'English', flag: '🇺🇸' },
  es: { name: 'Español', flag: '🇪🇸' },
  fr: { name: 'Français', flag: '🇫🇷' },
  de: { name: 'Deutsch', flag: '🇩🇪' },
  zh: { name: '中文', flag: '🇨🇳' }
};

// Dynamic import function for translation files
const loadTranslation = async (language) => {
  try {
    const module = await import(`./locales/${language}/translation.json`);
    return module.default;
  } catch (error) {
    console.warn(`Translation file for ${language} not found, falling back to English`);
    const fallbackModule = await import('./locales/en/translation.json');
    return fallbackModule.default;
  }
};

// Initialize i18n with dynamic loading
const initializeI18n = async () => {
  const resources = {};
  
  // Load all supported languages
  for (const [code] of Object.entries(supportedLanguages)) {
    resources[code] = {
      translation: await loadTranslation(code)
    };
  }

  return new Promise((resolve, reject) => {
    i18n
      .use(LanguageDetector)
      .use(initReactI18next)
      .init({
        resources,
        fallbackLng: 'en',
       // debug: process.env.NODE_ENV === 'development',
        debug: false,  
        
        interpolation: {
          escapeValue: false, // React already escapes values
        },
        
        detection: {
          order: ['localStorage', 'navigator'],
          caches: ['localStorage'],
        },

        // Add missing key handler
        saveMissing: true,
        missingKeyHandler: (lng, ns, key, fallbackValue) => {
          //console.warn(`Missing translation key: ${key} for language: ${lng}`);
          return fallbackValue || key;
        }
      }, (err, t) => {
        if (err) {
          console.error('i18n initialization error:', err);
          reject(err);
        } else {
          console.log('i18n initialized successfully');
          resolve();
        }
      });
  });
};

// Export the initialization function and supported languages
export { initializeI18n, supportedLanguages };
export default i18n; 